import { render, staticRenderFns } from "./SelectBoxItem.vue?vue&type=template&id=4d3dc894&scoped=true&"
import script from "./SelectBoxItem.vue?vue&type=script&lang=js&"
export * from "./SelectBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./SelectBoxItem.vue?vue&type=style&index=0&id=4d3dc894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3dc894",
  null
  
)

export default component.exports